import { Id, TextField } from "@dgs/core";
import { TFunction } from "i18next";
import { ReactNode } from "react";
import {
	ContactAttributeRequest,
	IContactAttributeBaseHandler,
	IContactAttributeHandler,
	IContactAttributeListHandler,
} from "../IContactAttributeHandler";

interface PrimaryEmailValue {
	id: Id;
	email: string;
	type: string;
	isPrimary: boolean;
}

export function createPrimaryEmailContactAttributeBaseHandler(id: Id): IContactAttributeBaseHandler {
	return {
		type: "PRIMARY_EMAIL",
		id,
		getLabel: (t) => t("Email"),
	};
}

export function createPrimaryEmailContactAttributeProfileHandler(
	id: Id,
	value: PrimaryEmailValue,
): IContactAttributeHandler<PrimaryEmailValue> {
	const baseHandler = createPrimaryEmailContactAttributeBaseHandler(id);
	return {
		...baseHandler,
		value,
		validate() {
			return null;
		},
		renderValue(): ReactNode {
			return this.value.email;
		},
		renderFormField(t: TFunction, prefix): ReactNode {
			return <TextField name={`${prefix ? `${prefix}.` : ""}${id}.value.email`} label={baseHandler.getLabel(t)} readOnly={true} />;
		},
		toRequestValue(): ContactAttributeRequest<PrimaryEmailValue> {
			return { id, value: this.value };
		},
	};
}

export function createPrimaryEmailContactAttributeListHandler(id: Id): IContactAttributeListHandler {
	const baseHandler = createPrimaryEmailContactAttributeBaseHandler(id);
	return {
		...baseHandler,
		getColumnSize: () => "1fr",
	};
}
